import GenericListModule from "../generic-list-module"
import FiltersManager from "../../../manager/filters/manager/filters-manager"
import {FilterCollectionType} from "../../../manager/filters/manager/@types"
import {EntityType} from "../../../gd/const/item"
import {GroupedData} from "../../../data-structures/group"

export default class GList_Filters extends FiltersManager {

    public module               : GenericListModule

    public _preFilters          : any

    constructor(module:GenericListModule, currentFilters:any, preFilters:any) {

        super([module.fields], currentFilters)

        this.collectionType     = FilterCollectionType.COLLECTION
        this.module             = module
        this._preFilters        = preFilters ? preFilters : {} // {fieldId: [values]} items filtering before filters manager processing (i.e. show/hide subfolders items)
    }

    setPrefilter = (filterId:string, values:any) => {
        this._preFilters[filterId] = values
        return this.module.onFiltersChanged()
    }

    removePrefilter = (filterId:string, values:any) => {
        delete this._preFilters[filterId]
        return this.module.onFiltersChanged()
    }

    get preFilters() {return this._preFilters}

    get modelsCollection() {
        return this.module.data.collection
    }

    get fieldsStructures(): {[key in EntityType]?: GroupedData} {
        return {
            [this.module.fields.entityType]: this.module.fields.structureFilterFields()
        }
    }

    async onChange(updatedFilter:any) {
        await super.onChange(updatedFilter);

        /*// every time filters change save value to local settings
        this.app.settings.filters = this.toObject();

        // show loading only for bigger projects
        this.app.dataContainer.length>70 && gd.bus.triggerEvent("app-show-loading-overlap");*/

        //set timeout for app-show-loading-overlap to have time for render
        setTimeout(()=>{
            this.module.data.process();
            this.module.reRender();
        },0);

        // hit callbacks
        return this.module.onFiltersChanged()
    }

    // apply filter and ghost when needed
    filterModels(items:any) {
        return super.filterModels(items)
    }

    /*// required while @ts-ignore for FiltersManager2 is present
    resetAll() {
        super.resetAll()
    }*/
}
